import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getChoicesBanks() {
    return defaultClient.get('/choices/banks/')
  },
}
